import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Utils } from "arv-reactcomponents";

import { getPageDetails } from "../../utils";

@withRouter
class StaticPageDesktopLeftNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLeftNavFixed: false,
    };

    this.scrollElement = this.scrollElement.bind(this);
    this.handleStickyLeftNav = this.handleStickyLeftNav.bind(this);
  }
  componentDidMount() {
    Utils.onElementScroll(window, ({ scrollTop }) => {
      this.handleStickyLeftNav(scrollTop || 0);
    });
  }

  scrollElement(value) {
    console.log(this.state.isLeftNavFixed);
    if (value && value.length) {
      window.location.hash = value;
    }
  }

  handleStickyLeftNav(scrollTop) {
    const { isLeftNavFixed } = this.state;
    if (scrollTop > 260 && !isLeftNavFixed) {
      this.setState({ isLeftNavFixed: true });
    } else if (scrollTop < 260 && isLeftNavFixed) {
      this.setState({ isLeftNavFixed: false });
    }
  }

  get isLeftNavFixed() {
    const { isLeftNavFixed } = this.state;
    return isLeftNavFixed ? "is-leftnav-fixed" : "";
  }

  render() {
    const page = getPageDetails(this.props.location.pathname);
    const title = page && page.leftNav && page.leftNav.title;
    const navListItems = page && page.leftNav && page.leftNav.navListItems;
    return (
      <div className={`nw-staticpage-leftnav ${this.isLeftNavFixed}`}>
        {title && <div className="nw-staticpage-leftnavtitle">{title}</div>}
        {navListItems && (
          <ul className="nw-staticpage-leftnavlist">
            {page.leftNav.navListItems.map((listItem, index) => (
              <li
                key={listItem.text}
                className="nw-staticpage-leftnavlistitems nw-staticpage-anchoritems"
                onClick={() => this.scrollElement(listItem.url)}
                role="presentation"
              >
                {listItem.text}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

StaticPageDesktopLeftNav.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StaticPageDesktopLeftNav,
  component: StaticPageDesktopLeftNav,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StaticPageDesktopLeftNav/index.js